export * from "./v5-themes";
import { subtleChildrenThemes } from "./subtleChildrenThemes";
import { createV5Theme } from "./v5-themes";
var themes = createV5Theme({
  childrenThemes: subtleChildrenThemes
});
themes.dark.background0075;
themes.dark_yellow.background0075;
themes.dark.background;
themes.dark.accent1;
themes.dark.nonValid;
export {
  themes
};
//# sourceMappingURL=v5-themes-subtle.js.map
